import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

export const AgGridDateCellEditor = forwardRef((props: any, ref) => {
  const [value, setValue] = useState<any>(null);

  // INIT VALUE
  useEffect(() => {
    if (props.value) {
      setValue(dayjs(props.value));
    } else {
      setValue(null);
    }
  }, [props.value]);

  // AG GRID API CONTRACT
  useImperativeHandle(ref, () => ({
    getValue() {
      return value ? value.toDate() : null;
    },

    isCancelAfterEnd() {
      return false;
    },
  }));

  const handleChange = (date: any) => {
    setValue(date);

    const jsDate = date ? date.toDate() : null;

    props.node.setDataValue(props.column.getColId(), jsDate);
    requestAnimationFrame(() => {
      props.api.stopEditing();
    });
  };

  return (
    <DatePicker
      autoFocus
      open={true}
      value={value}
      format="MM/DD/YYYY"
      onChange={handleChange}
      style={{ width: "100%" }}
    />
  );
});
